module.exports = __webpack_public_path__ + "static/media/3.e098a3c3.svg";